<template>
	<div>
		<home-nav></home-nav>
		<div class="main-top">

			<section v-if="salon != null" v-bind:style="{ backgroundImage: 'url(' + sortImages(salon.images).home_picture + ')' }" id="salon-banner" class="salon-banner-area">
				<div class="overlay overlay-bg"></div>
				<div class="container">
					<div class="row align-items-center justify-content-between">
						<div class="col-12 salon-banner-content">
							<div class="my-5 text-center">
								<h1>{{salon.name}}</h1>
								<div v-if="favoriteAlready != null">
									<p v-if="user != null && !favoriteAlready" class="text-white link-nav"><span class="far fa-heart mr-2"></span> <a @click="addToFavorite()" href="#"> Dodaj na listu omiljenih salona</a></p>
									<p v-if="user != null && favoriteAlready" class="text-white link-nav"><span class="far fa-heart checked mr-2"></span> <a @click="removeToFavorite()" href="#"> Ukloni s liste omiljenih salona</a></p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>

			<div id="main" class="container">
				<div class="row">
					<div id="main-content" class="col-lg-8 pb-3 pb-md-0">
						<div style="padding: 25px 0px;" v-if="fetching" class="fetching">
							<loader></loader>
						</div>
						<section v-if="salon != null && !fetching" id="salon" class="main-content-area-salon">
							<div class="container content-container">
								<div id="salon-info" class="mb-4">
									<div class="col-12 d-flex justify-content-left">
										<div class="">
											<span :class="salon.rating >= 1 ? 'fa fa-star checked':'fa fa-star'"></span>
											<span :class="salon.rating >= 2 ? 'fa fa-star checked':'fa fa-star'"></span>
											<span :class="salon.rating >= 3 ? 'fa fa-star checked':'fa fa-star'"></span>
											<span :class="salon.rating >= 4  ? 'fa fa-star checked':'fa fa-star'"></span>
											<span :class="salon.rating == 5 ? 'fa fa-star checked mr-2':'fa fa-star mr-2'"></span>
											{{salon.rate_count}} ocjena
										</div>
										<div class="ml-3"><span class="fa fa-comments mr-2"></span> {{salon.comment_count}} komentara</div>
										<div class="ml-3"><span class="fa fa-heart mr-2"></span> {{salon.favorites}} omiljenih</div>
									</div>
								</div>
								<div id="salon-galerija" class="mb-4">
									<div class="col-12">
										<h3 class="section-title">Slike</h3>
										<div class="row mt-3 no-gutters">
											<div v-for="(img,index) in salon.images.filter((e)=> e.type == 3)" :key="index" class="col-4">
												<!--<div class="img-wrapper">
												<a @click="setImage(img.id)" title="Preview">
													<img :src="img.filename" alt="" class="img-responsive">
													</a>
												</div> -->
												<a @click="setImage(img.id)" title="Preview">
													<div v-bind:style="{ backgroundImage: 'url(' + img.filename+ ')' }" class="img-wrapper"></div>
												</a>
											</div>
										</div>
									</div>
								</div>
								<div id="salon-usluge" class="mb-4" style="margin-top:-80px;padding-top: 80px;">
									<div class="col-12">
										<h3 class="section-title">Usluge</h3>
										<div class="row no-gutters mt-3">
											<div class="col-12">
												<table id="table-frizure" class="table table-sm">
													<tbody>
														<tr v-for="(serv,index) in salon.services.filter((d)=>d.featured == 1) " :key="index">
															<td class="text-left">
																<p>{{serv.name}}<span v-if="serv.action" class="badge badge-danger akcija">AKCIJA!</span></p>
																<small>{{serv.description}}</small>
															</td>
															<td class="text-right td-flex">
																<div class="td-2 mr-3">
																	<p>{{serv.price}} kn</p>
																	<small>{{serv.time}} min</small>
																</div>
																<!--
																<div class="td-1">
																	<a href="#" @click="selectService(serv)" class="btn fs-btn small dark book">BOOK</a>
																</div>
																-->
															</td>
														</tr>
													</tbody>
												</table>
												<div class="collapse" id="collapseTable">
													<table id="collapseTable" class="table table-sm">
														<tbody>
															<tr v-for="(serv,index) in salon.services.filter((d)=>d.featured != 1) " :key="index">
																<td class="text-left">
																	<p>{{serv.name}}<span v-if="serv.action" class="badge badge-danger akcija">AKCIJA!</span></p>
																	<small>{{serv.description}}</small>
																</td>
																<!--
																<td class="text-right td-flex">
																	<div class="td-2 mr-3">
																		<p>{{serv.price}} kn</p>
																		<small>{{serv.time}} min</small>
																	</div>
																	<div class="td-1"><a href="#" @click="selectService(serv)" class="btn fs-btn small dark book">Book</a></div>
																</td>
																-->
															</tr>
														</tbody>
													</table>
												</div>
											</div>
											<div class="col-12 text-center btn-more-services">
												<a @click="changeBotunText" class="btn fs-btn medium dark-border mt-3" data-toggle="collapse" href="#collapseTable" role="button" aria-expanded="false" aria-controls="collapseTable">{{botunText}}</a>
											</div>
										</div>
									</div>
								</div>
								<div id="salon-komentari" class="mb-4">
									<div class="col-12">
										<h3 class="section-title">Komentari</h3>
									</div>
									<div class="col-12 mt-3">
										<div class="container">
											<div class="row align-items-center">
												<div class="col-6 text-center">
													<div class="ratings-left-ukupno">
														<h3>Ukupno</h3>
													</div>
													<div class="ratings-left-rating">
														<h1>{{Number(salon.rating).toFixed(1).toString().replace('.',',')}}</h1>
													</div>
													<div class="ratings-left-num">
														<p>({{salon.rate_real_count}} ocjena)</p>
													</div>
												</div>
												<div class="col-6">
													<p class="ratings-stars-row">
														<span class="fa fa-star checked"></span>
														<span class="fa fa-star checked"></span>
														<span class="fa fa-star checked"></span>
														<span class="fa fa-star checked"></span>
														<span class="fa fa-star checked"></span>
														<span class="ratings-ocjena">({{salon.rates['5']}})</span>
													</p>
													<p class="ratings-stars-row">
														<span class="fa fa-star checked"></span>
														<span class="fa fa-star checked"></span>
														<span class="fa fa-star checked"></span>
														<span class="fa fa-star checked"></span>
														<span class="fa fa-star"></span>
														<span class="ratings-ocjena">({{salon.rates['4']}})</span>
													</p>
													<p class="ratings-stars-row">
														<span class="fa fa-star checked"></span>
														<span class="fa fa-star checked"></span>
														<span class="fa fa-star checked"></span>
														<span class="fa fa-star"></span>
														<span class="fa fa-star"></span>
														<span class="ratings-ocjena">({{salon.rates['3']}})</span>
													</p>
													<p class="ratings-stars-row">
														<span class="fa fa-star checked"></span>
														<span class="fa fa-star checked"></span>
														<span class="fa fa-star"></span>
														<span class="fa fa-star"></span>
														<span class="fa fa-star"></span>
														<span class="ratings-ocjena">({{salon.rates['2']}})</span>
													</p>
													<p class="ratings-stars-row">
														<span class="fa fa-star checked"></span>
														<span class="fa fa-star"></span>
														<span class="fa fa-star"></span>
														<span class="fa fa-star"></span>
														<span class="fa fa-star"></span>
														<span class="ratings-ocjena">({{salon.rates['1']}})</span>
													</p>
												</div>
											</div>
										</div>
									</div>
									<div v-if="canComment" class="col-12 mt-5 mb-5">
										<div class="row no-gutters">
											<div class="col-12 komentar-header">
												<div class="komentar-header-left">
													<!-- <h4 class="komentar-username">{{comment.user.name}}</h4> -->
												</div>
												<div class="komentar-header-right">
													<small class="komentar-date">{{format_croatia_date(new Date().toDateString())}}</small>
												</div>
											</div>
											<div class="col-12 komentar-body">
												<div class="form-group">
													<textarea v-model="comment.text" style="width:100%" class="form-control" id="" rows="5" placeholder="Ostavi svoj komentar ovdje."></textarea>
												</div>
												<div class="d-flex space-between">
													<div class="komentar-header-left">
														<div>
															<span>OCIJENI USLUGU</span>
															<p>
																<span @click="comment.rating=1" :class="comment.rating >= 1 ? 'fa fa-star checked':'fa fa-star'"></span>
																<span @click="comment.rating=2" :class="comment.rating >= 2 ? 'fa fa-star checked':'fa fa-star'"></span>
																<span @click="comment.rating=3" :class="comment.rating >= 3 ? 'fa fa-star checked':'fa fa-star'"></span>
																<span @click="comment.rating=4" :class="comment.rating >= 4 ? 'fa fa-star checked':'fa fa-star'"></span>
																<span @click="comment.rating=5" :class="comment.rating == 5 ? 'fa fa-star checked':'fa fa-star'"></span>
															</p>
														</div>
													</div>
													<div class="komentar-header-right">
														<button @click="submitComment()" class="btn fs-btn dark">POŠALJI</button>
													</div>
												</div>
											</div>
											<div class="mt-2">
												<notify></notify>
												<loader v-if="saveCommentLoading" color='red'></loader>
											</div>
										</div>
									</div>
									<div class="col-12">
										<div class="row mt-3">
											<div v-for="(comment,index) in comments" :key="index" class="col-12 komentar-div">
												<div class="row no-gutters">
													<div class="col-12 komentar-header">
														<div class="komentar-header-left">
															<h4 class="komentar-username">{{comment.user.name}}</h4>
															<p class="mt-1">
																<span :class="comment.rating >= 1 ? 'fa fa-star checked':'fa fa-star'"></span>
																<span :class="comment.rating >= 2 ? 'fa fa-star checked':'fa fa-star'"></span>
																<span :class="comment.rating >= 3 ? 'fa fa-star checked':'fa fa-star'"></span>
																<span :class="comment.rating >= 4  ? 'fa fa-star checked':'fa fa-star'"></span>
																<span :class="comment.rating == 5 ? 'fa fa-star checked':'fa fa-star'"></span>
															</p>
														</div>
														<div class="komentar-header-right">
															<small class="komentar-date">{{format_croatia_date(new Date(comment.created_at).toDateString())}}</small>
														</div>
													</div>
													<div class="col-12 komentar-body">
														<p class="komentar-tekst">{{comment.text}}</p>
													</div>
												</div>
												<div v-for="(response,index) in comment.response" :key="index" class="col-12 komentar-div response">
													<div class="row no-gutters">
														<div class="col-12 komentar-header">
															<div class="komentar-header-left">
																<h4 v-if="response.user.id == salon.user_id" class="komentar-username">{{response.salon.name}}</h4>
																<h4 v-else class="komentar-username">{{response.user.name}}</h4>
															</div>
															<div class="komentar-header-right">
																<small class="komentar-date">{{format_croatia_date(new Date(response.created_at).toDateString())}}</small>
															</div>
														</div>
														<div class="col-12 komentar-body">
															<p class="komentar-tekst">{{response.text}}</p>
														</div>
													</div>
												</div>
											</div>
											<div style="margin:auto" v-if="loadingComment">
												<loader color='red'></loader>
											</div>
										</div>
									</div>

									<div v-if="last_page > 1" class="col-12">
										<nav aria-label="Page navigation">
											<ul class="pagination justify-content-center">
												<li class="page-item align-self-center">
													<a @click="loadComment(comment_current_page <=0 ? 0:comment_current_page - 1)" class="page-link" aria-label="Previous">
														<span aria-hidden="true">&laquo;</span>
														<span class="sr-only">Previous</span>
													</a>
												</li>
												<li v-for="(page,index) in pagination" :key="index" :class="page == comment_current_page ? 'page-item active':'page-item '"><a class="page-link" @click="loadComment(page)">{{page}}</a></li>
												<li class="page-item">
													<a @click="loadComment(comment_current_page >= last_page ? last_page:comment_current_page + 1)" class="page-link" aria-label="Next">
														<span aria-hidden="true">&raquo;</span>
														<span class="sr-only">Next</span>
													</a>
												</li>
											</ul>
										</nav>
									</div>

								</div>
							</div>
						</section>
					</div>
					<div v-if="salon != null" id="sidebar" class="col-lg-4 pb-3 pb-md-0">
						<div class="container stickey-top">
							<div class="row">
								<div id="sidebar-radno-vrijeme" class="col-12 content-container">
									<ul class="fa-ul">
										<li class="mb-2">
											<span class="fa-li"><i class="fa fa-map-marker"></i></span>
											<b>Adresa: </b>{{salon.address}}, {{salon.city}}
										</li>
										<li class="mb-2"><span class="fa-li"><i class="fa fa-phone"></i></span><b>Kontakt: </b>{{salon.contact}}</li>
										<li class="mb-2">
											<span class="fa-li"><i class="fa fa-clock"></i></span>
											<b>Radno vrijeme: </b>
											<ul id="radno-vrijeme-fr" class="">
												<li v-for="(day,index) in days" :key="index" class="d-flex">
													<div class="d-flex align-content-start flex-wrap">
														<div class="dan">{{day.day}}</div>
													</div>
													<div class="d-flex align-content-end flex-wrap">
														<div v-if="day.data.start == '00:00:00'" class="vrijeme ml-auto">Ne radimo</div>
														<!-- <span v-if="day.data.start != '00:00:00'"> -->
														<div v-if="day.data.start != '00:00:00'" class="vrijeme ml-auto">
															{{day.data.start.substr(0,5)}}
														</div>
														<div v-if="day.data.ps != '00:00:00' && day.data.start != '00:00:00'" class="vrijeme ml-auto">
															- {{day.data.ps.substr(0,5)}}
														</div>
														<div v-if="day.data.pk != '00:00:00' && day.data.start != '00:00:00'" class="vrijeme ml-auto">
															| {{day.data.pk.substr(0,5)}}
														</div>
														<div v-if="day.data.end != '00:00:00' && day.data.start != '00:00:00'" class="vrijeme ml-auto">
															- {{day.data.end.substr(0,5)}}
														</div>
														<!-- </span> -->
													</div>
												</li>
											</ul>
										</li>
									</ul>
								</div>
								<div id="sidebar-mapa" class="col-12">
									<div class="embed-responsive embed-responsive-4by3 my-4" v-html="salon.map"></div>
								</div>
								<div id="sidebar-info" class="col-12 content-container">
									<h3 class="section-title mb-3">O nama</h3>
									<p class="text-justify">{{salon.description}}</p>
									<ul class="fa-ul">
										<li class="mb-2"><span class="fa-li"><i class="fa fa-credit-card"></i></span><b>Način plaćanja: </b>{{salon.payment_methods}}</li>
										<!-- <li class="mb-2"><span class="fa-li"><i class="fas fa-walking"></i></span><b>Dolazak doma: </b>{{salon.home_service == 1 ? 'Dostupno':'Nije dostupno'}}</li> -->
										<li class="mb-2"><span class="fa-li"><i class="fas fa-wifi"></i></span><b>Wifi: </b>{{salon.wifi == 1 ? 'Dostupno':'Nije dostupno'}}</li>
										<li class="mb-2"><span class="fa-li"><i class="fas fa-parking"></i></span><b>Parking: </b>{{salon.parking == 1 ? 'Dostupno':'Nije dostupno'}}</li>
										<li class="mb-2"><span class="fa-li"><i class="fab fa-accessible-icon"></i></span><b>Pristup za inv. osobe: </b>{{salon.inviting_persons == 1 ? 'Dostupno':'Nije dostupno'}}</li>
									</ul>
								</div>
								<div id="sidebar-social" class="col-12 content-container text-center">
									<ul class="social-network social-circle">
										<li><a :href="salon.facebook" class="icoFacebook" title="Facebook"><i class="fab fa-facebook-f"></i></a></li>
										<li><a :href="salon.instagram" class="icoInstagram" title="Instagram"><i class="fab fa-instagram"></i></a></li>
										<li><a :href="salon.website" class="icoWebsite" title="Website"><i class="fas fa-globe"></i></a></li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					<!-- Istaknuti saloni /-->
					<section style="width:100%" id="popularni-saloni" class="main-content-area py-5">
						<div class="container content-container">
							<div class="row h-100">
								<div class="col-12">
									<div class="mb-5">
										<h3 class="float-left section-title">Istaknuti saloni</h3>
										<!-- <a id="collapseTableBtn" class="btn fs-btn medium primary float-right" data-toggle="collapse" href="#collapseTable" role="button" aria-expanded="false" aria-controls="collapseTable">Prikaži više</a> -->
									</div>
								</div>
							</div>
							<div class="row no-gutters owl-container h-100">
								<div id="salonCarol" v-if="!fetching" class="active-recent-blog-carusel owl-theme">
									<div v-for="(salon,index) in salons" :key="index" class="single-recent-blog-post item">
										<a :href="'/salon/'+salon.name">
											<div class="content-box">

												<div v-bind:style="'background-image:url('+ salon.profile_image +')'" class="img-wrapper"></div>
												<!--<div class="img-wrapper">
													<img :src="salon.profile_image" alt="" class="img-responsive">
													<h3 class="akcija"><span class="badge badge-danger">AKCIJA!</span></h3>
												</div> -->
												<div class="container">
													<div class="row">
														<div class="col-12">
															<div class="index-salon-text">
																<h4>{{salon.name}}</h4>
																<p v-if="salon.address"> {{salon.address.length > 40 ? salon.address.substr(0,40)+'..':salon.address}}</p>
															</div>
														</div>
														<div class="col-12">
															<div class="index-salon-rates">
																<div class="index-salon-stars">
																	<span :class="salon.rating >= 1 ? 'fa fa-star checked':'fa fa-star'"></span>
																	<span :class="salon.rating >= 2 ? 'fa fa-star checked':'fa fa-star'"></span>
																	<span :class="salon.rating >= 3 ? 'fa fa-star checked':'fa fa-star'"></span>
																	<span :class="salon.rating >= 4  ? 'fa fa-star checked':'fa fa-star'"></span>
																	<span :class="salon.rating == 5 ? 'fa fa-star checked':'fa fa-star'"></span>
																</div>
																<div>
																	<small>{{salon.rate_count}} ocjene</small>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</a>
									</div>
								</div>
								<div style="margin:auto;display:block" v-if="!fetching && salons.length == 0">Nema istaknutih salona</div>
								<div class="owl-theme">
								</div>
							</div>
						</div>
					</section>
				</div>
			</div>
		</div>

		<div v-if="display_book" id="bookMod">
			<div class="content">
				<div :class="!ready ? 'row p-0 m-auto rowcontent':'row p-0 m-0 rowcontent ready'">
					<div class="col-12 my-3 d-flex">
						<div class="ml-auto">
							<button @click="closeAll(); display_book=false" id="close" type="button" class="close" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
					</div>
					<!-- kalendar i termini section -->
					<div :class="!ready ? 'col-12 col-lg-8':'closed'">
						<div class="main-content-area mb-2">
							<div class="container content-container">

								<div class="form-group">
									<label for="">
										<h4 class="bk-subt mb-3">Odaberi djelatnika</h4>
									</label>
									<select @change="toggleEmployee()" v-model="booking.employee" name="" id="" class="form-control">
										<!-- <option value="0"></option> -->
										<option v-for="(employee,index) in employees_services" :key="index" :value="employee.id">{{employee.name}}</option>
									</select>
								</div>
							</div>
						</div>
						<div class="main-content-area">
							<div class="container content-container">
								<div id="calendar">
									<!-- kalendar -->
									<div v-if="level == 0">
										<h4 class="bk-subt mb-3">Odaberi datum</h4>
										<FullCalendar defaultView="dayGridMonth" :plugins="calendarPlugins" @dateClick="handleDateClick" @eventClick="handleEventClick" ref="fullCalendar" :events="[]" :firstDay="1" :header="{left: 'prev',center: 'title',right:'next'}" locale="hr" />


									</div>
									<!-- termini -->
									<div v-if="level == 1">
										<h4 class="bk-subt mb-3">Odaberi vrijeme</h4>
										<div class="tool">
											<button @click="returnToLevel1()" class="btn fs-btn dark-border small"><i class="fas fa-arrow-left"></i></button>
											<h4>Slobodni termini za <b>{{custom_date(new Date(booking.day))}}</b></h4>
										</div>
										<div class="apmt">
											<div class="mer">
												<h4 class="mb-2">JUTRO</h4>
												<div>
													<div v-for="(service,index) in morning" :key="index" :class="service.service != null ?'aptc d-none':'aptc'">
														<div @click="setTime(service.data.time)" :class="service.service == null && booking.time == service.data.time ? 'time-apmt-box selectedTime':'time-apmt-box'">
															<span class="time-box">
																<div class="time-box-time">{{service.time}}</div>
																<span v-if="service.service != null" class="text-danger booked d-none"></span>
																<span v-else class="text-danger available d-none"></span>
															</span>
															<div v-if="service.service != null" class="inner">
																<b class="service">{{service.service.services.name}}</b>
																<div style="justify-content:space-between" class="d-flex">
																	<span style="white-space: nowrap;width: 54%;" class="">{{service.service.employee.name}}</span>
																	<span class="">{{service.service.time_total}} min</span>
																</div>
															</div>
															<div class='add-book' v-else>
																<a href="#">
																	<!--<i class="fas fa-plus"></i>
															<span class="d-block">select time</span>-->
																</a>
															</div>
														</div>
													</div>
												</div>
											</div>
											<div class="mer">
												<h4 class="mb-2">POSLIJE PODNE</h4>
												<div>
													<div v-for="(service,index) in afternoon" :key="index" :class="service.service != null ?'aptc d-none':'aptc'">
														<div @click="setTime(service.data.time)" :class="service.service == null && booking.time == service.data.time ? 'time-apmt-box selectedTime':'time-apmt-box'">
															<span class="time-box">
																<div class="time-box-time">{{service.time}}</div><span v-if="service.service != null" class="text-danger booked"></span> <span v-else class="text-danger available"></span>
															</span>
															<div v-if="service.service != null" class="inner">
																<b class="service d-block">{{service.service.services.name}}</b>
																<div style="justify-content:space-between" class="d-flex">
																	<span style="white-space: nowrap;width: 54%;" class="">{{service.service.employee.name}}</span>
																	<span class="">{{service.service.time_total}} min</span>
																</div>
															</div>
															<div class='add-book' v-else>
																<a href="#">
																	<!--<i class="fas fa-plus"></i>
															<span class="d-block">select time</span>-->
																</a>
															</div>
														</div>
													</div>
												</div>
											</div>
											<div class="mer">
												<h4 class="mb-2">NAVEČER</h4>
												<div>
													<div v-for="(service,index) in evening" :key="index" :class="service.service != null ?'aptc d-none':'aptc'">
														<div @click="setTime(service.data.time)" :class="service.service == null && booking.time == service.data.time ? 'time-apmt-box selectedTime':'time-apmt-box'">
															<span class="time-box">
																<div class="time-box-time">{{service.time}}</div><span v-if="service.service != null" class="text-danger booked"></span> <span v-else class="text-danger available"></span>
															</span>
															<div v-if="service.service != null" class="inner">
																<b class="service d-block">{{service.service.services.name}}</b>
																<div style="justify-content:space-between" class="d-flex">
																	<span style="white-space: nowrap;width: 54%;" class="">{{service.service.employee.name}}</span>
																	<span class="">{{service.service.time_total}} min</span>
																</div>
															</div>
															<div class='add-book' v-else>
																<a href="#">
																	<!--<i class="fas fa-plus"></i>
															<span class="d-block">select time</span>-->
																</a>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<!-- Loader -->
									<div v-if="loadingBookings" class="loading">
										<div class="loader">
											<loaderCircle :color="'white'"></loaderCircle>
											<p style="color:white">Provjeravamo rezervacije...</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- detalji rezervacije section -->
					<div :class="ready ? 'col-12 col-lg-4 nd_part open':'col-12 col-lg-4 nd_part'">
						<div class="main-content-area mb-2">
							<div class="container content-container">
								<!-- detalji rezervacije -->
								<div v-if="!showServices" class="raise">
									<div class="tool mb-3">
										<button :disabled="!ready" @click="ready=false" :class=" ready ? 'btn fs-btn dark-border small':'d-none'"><i class="fas fa-arrow-left"></i></button>
										<h4 class="bk-subt">Detalji rezervacije</h4>
									</div>
									<div class="prop">
										<b>Salon</b>
										<span>{{salon.name}}</span>
									</div>
									<div class="prop">
										<b>Usluge</b>
										<span>{{booking.services.map((d)=> d.name).join(', ')}} </span>
									</div>
									<div class="prop">
										<b>Djelatnik</b>
										<span>{{booking.employee_name == '' ? '':booking.employee_name}}</span>
									</div>
									<div class="prop">
										<b>Trajanje</b>
										<span>{{getServicesTimeTotal()}} min</span>
									</div>
									<div class="prop">
										<b>Datum</b>
										<span>{{booking.day == '' ? '':format_croatia_date2(new Date(booking.day.split('-')[0],booking.day.split('-')[1],booking.day.split('-')[2]))}}</span>
									</div>
									<div class="prop">
										<b>Vrijeme</b>
										<span>{{booking.time == '' ? '':reformatTime(booking.time)}}</span>
									</div>
									<div class="prop">
										<b>Cijena</b>
										<span>{{getServicesPriceTotal()}} kn</span>
									</div>
									<div class="prop mb-2">
										<b class="dark-color"><a @click="sortServices()"><i class="fas fa-plus"></i> Dodaj uslugu </a><!-- <span v-if="booking.employee > 0">od {{booking.employee_name}}</span>--> </b>
									</div>
									<!-- <div v-if="user.id == salon.user_id" class="form-group">
                            <label for="">Booking on behave of:</label>
                            <p class="text-danger">The customer must have this mail registered on this platform</p>
                            <input type="email" v-model="booking.email" class="form-control" placeholder="Enter customer's email" />
                        </div> -->
									<div class="form-group">
										<textarea v-model="booking.note" class="form-control" id="" style="width:100%" rows="5" placeholder="Dodaj napomenu"></textarea>
									</div>
									<notify></notify>
									<div class="btn-group-book" role="group">
										<button :disabled="!verifyOrderDetails()" @click="book()" :class=" verifyOrderDetails() ? 'btn fs-btn dark ready mr-1':'btn fs-btn dark mr-1'">
											<loaderCircle v-if="bookLoading"></loaderCircle>
											<span v-else>BOOK</span>
										</button>
										<button @click="closeAll(); display_book=false" class="btn fs-btn primary-border">Odustani</button>
									</div>
								</div>
								<!-- dodaj uslugu -->
								<div class="raise" v-else style="margin-bottom:20px">
									<div style="justify-content:space-between" class="d-flex mb-3">
										<h4 class="bk-subt">Dodaj usluge</h4>
									</div>
									<div v-for="(serv,index) in available_services" :key="index" class="form-group d-flex align-content-center justify-content-between">
										<label class="d-flex align-items-center mr-3">
											<input @click="addService($event,serv)" :checked="booking.services.find((d)=> d.id == serv.id)" style="width:1em;height:1em" type="checkbox" name="" class="form-control" :id="'check'+index">
											<span class="ml-3">{{serv.name}}</span>
										</label>
										<div class="float-right">
											<div class="float-right"><b>{{serv.price}} kn</b></div>
											<div>{{serv.time}} min</div>
										</div>
									</div>
									<notify></notify>
									<button @click="closeServiceList()" class="btn fs-btn dark btn-block">Nastavi</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<login></login>
		<image-viewer v-if="image_viewer" :hide="true"></image-viewer>
		<home-footer></home-footer>
	</div>
</template>

<script>
	import {
		mapState
	} from 'vuex';
	import image_viewer from './vendor/imageviewer'
	import FullCalendar from '@fullcalendar/vue'
	import dayGridPlugin from '@fullcalendar/daygrid'
	import interactionPlugin from '@fullcalendar/interaction';
	import login from '../layouts/login_modal';
	import {
		module_mixin
	} from '../../mixins/index';
	export default {
		name: 'salon-list',
		mixins: [module_mixin],
		components: {
			'image-viewer': image_viewer,
			FullCalendar,
			login
		},
		computed: {
			...mapState({
				user: (state) => state.user,
				loader: (state) => state.loader,
				endpoint: (state) => state.endpoint,
				salons: (state) => state.featured_salons,
				salon: (state) => state.salon,
				token: (state) => state.token,
				image_viewer: (state) => state.image_viewer,
			})
		},
		data() {
			return {
				level: 0,
				fetching: false,
				loadingComment: false,
				comment_current_page: 1,
				last_page: 0,
				comment: {
					user: {},
					rating: 0,
					text: ''
				},
				comments: [],
				pagination: [],
				favoriteAlready: null,
				employees_services: [],
				display_book: false,
				booking: {
					employee: 0,
					employee_name: '',
					services: [],
					time: '',
					day: '',
					note: ''
				},
				calendarPlugins: [dayGridPlugin, interactionPlugin],
				calendar: null,
				bookLoading: false,
				loading: false,
				events: [],
				bookings: {},
				loadingBookings: false,
				view_events: [],
				times: [],
				morning: [],
				afternoon: [],
				evening: [],
				ready: false,
				sent: false,
				rem: 0,
				canComment: false,
				saveCommentLoading: false,
				days: [{
						day: 'Pon: ',
						value: 'Mon',
						data: {
							start: '',
							ps: '',
							pk: '',
							end: ''
						}
					},
					{
						day: 'Uto: ',
						value: 'Tue',
						data: {
							start: '',
							ps: '',
							pk: '',
							end: ''
						}
					},
					{
						day: 'Sri: ',
						value: 'Wed',
						data: {
							start: '',
							ps: '',
							pk: '',
							end: ''
						}
					},
					{
						day: 'Čet: ',
						value: 'Thu',
						data: {
							start: '',
							ps: '',
							pk: '',
							end: ''
						}
					},
					{
						day: 'Pet: ',
						value: 'Fri',
						data: {
							start: '',
							ps: '',
							pk: '',
							end: ''
						}
					},
					{
						day: 'Sub: ',
						value: 'Sat',
						data: {
							start: '',
							ps: '',
							pk: '',
							end: ''
						}
					},
					{
						day: 'Ned: ',
						value: 'Sun',
						data: {
							start: '',
							ps: '',
							pk: '',
							end: ''
						}
					},
				],
				showServices: false,
				available_services: [],
				prevHead: '',
				botunText: "Prikaži više"
			}
		},
		methods: {
			returnToLevel1() {
				this.level = 0;
				var service = this.booking.services[0];
				this.employees_services = this.salon.employees.filter((empl) => empl.services.split(',').find((d) => d == service.name));
				// this.booking.employee=0;
				this.toggleEmployee();
			},
			addService(e, service) {

				// if(this.booking.day == '' && this.booking.services.length > 0){
				//     console.log('clicked');
				//     e.srcElement.checked=false;
				//     this.$store.commit('setNotification',{'type':2,msg:'You need to pick a date first',unset:false});
				//     return false;
				// }
				if (this.booking.services.find((d) => d.id == service.id)) {
					this.booking.services = this.booking.services.filter((d) => d.id != service.id);
				} else {
					// console.log('added')
					this.booking.services.push(service);

					if (this.booking.time == '' && this.booking.services.length > 0) { //if user hasn't selected a time yet dont bother checking the if time is enough or not
						return false;
					}
					if (!this.setTime(this.booking.time)) { //checking if the new added service wont extend beyond the planned time
						this.booking.services = this.booking.services.filter((d) => d.id != service.id);
						this.showServices = false;
						this.ready = false;
					}
				}
			},
			closeServiceList() {
				this.showServices = false;
			},
			getServicesTimeTotal() {
				var time = 0;
				this.booking.services.forEach((serv) => {
					time += parseInt(serv.time);
				})
				return time;
			},
			getServicesPriceTotal() {
				var time = 0;
				this.booking.services.forEach((serv) => {
					time += parseFloat(serv.price);
				})
				return time;
			},
			submitComment() {
				if (this.comment.text == '') {
					this.$store.commit('setNotification', {
						'type': 2,
						msg: 'Vaš komentar je prazan!'
					});
					return false;
				}

				this.saveCommentLoading = true;
				this.booking.salon = this.salon.id;
				this.$store.dispatch('post', {
						endpoint: this.endpoint + 'comment-salon?token=' + this.token,
						details: this.comment
					})
					.then((data) => {
						if (data.data.status) {
							this.$store.commit('setNotification', {
								'type': 1,
								msg: 'Komentar je uspješno poslan.',
								unset: false
							});
							this.canComment = false;
							this.comments.unshift(data.data.data);
						} else {
							this.$store.commit('setNotification', {
								'type': 2,
								msg: data.data.message
							});
						}
						this.saveCommentLoading = false;
					})
					.catch(() => {
						// console.log(error.request);
						this.saveCommentLoading = false;
						this.$store.commit('setNotification', {
							'type': 2,
							msg: "Dogodila se neočekivana greška. Molimo Vas provjerite Vašu internet vezu."
						});
					});
			},
			closeAll() {
				this.display_book = 0;
				this.level = 0;
				this.booking = {
					employee: 0,
					employee_name: '',
					services: [],
					time: '',
					day: '',
					note: ''
				};
				this.sent = false;
				this.ready = false;
			},
			filterEmployeeSchedule(hours = []) {
				if (this.booking.employee > 0) {
					var shifts = this.salon.upcomingEvents.filter((d) => (d.employee_id == this.booking.employee && this.booking.day == d.date))
					// console.log(shifts);
					if (shifts[0] != null) {
						if (shifts[0].shift != null) {
							hours = [];
							var start = parseInt(shifts[0].shift.start.split(':')[0]);
							var end = parseInt(shifts[0].shift.end.split(':')[0]);
							while (start < end && start <= 22) {
								hours.push(start);
								start += 1;
							}
						}
					}

				}
				return hours;
			},
			reformatHour(hour) {
				return hour.toString().length > 1 ? hour + '' : '0' + hour;
			},
			reformatMin(min) {
				return min.toString().length > 1 ? min + ' ' : '0' + min;
			},
			reformatMonth(month) {
				return month.toString().length > 1 ? month + '' : '0' + month;
			},
			arrangeTimeWithBookings(data) {
				var temp = [];
				var passed_hours = [];
				var mer = '';
				data.forEach((hour) => {
					mer = hour < 12 ? '' : '';
					var min_last_booked = 0;
					var once_inserted = false;
					// console.log(this.view_events);
					// console.log(this.booking.employee);
					//what happens here is that i pick all event that occurs in between that hour into books 
					var books = this.view_events.filter((d) => d.time.split(':')[0] == hour && d.employee_id == this.booking.employee);


					if (books.length == 0) {
						//if we find no booking at this hour and we have the last hour booking that spanned into this current hour (that is when we have a rem > 0 )
						if (this.rem > 0 && this.rem < 60) {
							var data = {
								time: this.reformatHour(hour) + ':' + this.reformatMin(this.rem) + mer.toUpperCase(),
								service: null,
								data: {
									time: hour + ':' + this.rem
								}
							};
							temp.push(data);

							if ((60 - this.rem) >= 20) { //checking to see the remaning minutes in this hours (after some bookings) can still accept some bookings so that we can make the time available
								// data={
								//     time:this.reformatHour(hour)+':'+this.reformatMin(this.rem+15)+mer.toUpperCase(),
								//     service:null,
								//     data:{time:hour+':'+(this.rem+15)}
								// }; 
								// temp.push(data);

								var temp_min2 = this.rem + 15;
								while (temp_min2 <= 45) {
									data = {
										time: this.reformatHour(hour) + ':' + this.reformatMin(temp_min2) + ' ' + mer.toUpperCase(),
										service: null,
										data: {
											time: hour + ':' + this.reformatMin(temp_min2)
										}
									};
									if (temp.find((d) => d.time == (data.time)) == undefined) {
										temp.push(data);
									}
									temp_min2 += 15;
								}
							}



							this.rem = 0;
							once_inserted = true;
						} else if (this.rem >= 60) {
							this.rem -= 60;
							if (this.rem == 0) {
								once_inserted = true;
							}
						}
					} else {
						if (this.rem > 0) {
							passed_hours.push(hour);
						}
						// console.log(hour+' books');
					}

					//am trying to retrieve all the time of booking within this hour then i will sort it 
					//then i will first check if the hour itself has a booking then if it doesn't i will then create a fake booking that contains only time field then push it into the books variable
					//then i will also push this current hour into booked_times for further processing
					var booked_times = JSON.parse(JSON.stringify(books)); //to avoid passing value by reference
					//removing ':' with '.'
					booked_times = booked_times.map((bk) => {
						bk.time = parseFloat(bk.time.replace(':', '.')).toFixed(2);
						return bk.time;
					});

					if (!booked_times.find((re) => re == hour) && !passed_hours.find((e) => e == hour) && books.length > 0) { //checking if there is a booking directly on this hour
						booked_times.push(hour + '.00');
						books.push({
							time: hour + ':00'
						}) //fake booking
					}

					booked_times.sort();
					books = booked_times.map((er) => {
						return books.find((ed) => ed.time.toString() == er.toString().replace('.', ':'));
					});

					books.forEach((book) => {
						// console.log(book);

						if (temp.find((d) => d.time == (book.time + mer.toUpperCase())) == undefined) { // to avoid displaying 2 bookings that will occur at thesame time

							if (book.services == null) { //checking if its a fake booking  then we will push an 'available' timeslot into this space
								temp.push({
									time: book.time + ' ' + mer.toUpperCase(),
									service: null,
									data: {
										time: book.time
									}
								});

							} else { // else if its not a fake booking then we will push a 'booked' timeslot into this space

								var check_min_last_booked = min_last_booked;

								book.services = typeof book.services == 'string' ? JSON.parse(book.services) : book.services;
								min_last_booked = parseInt(book.time.toString().split(':')[1]);

								/*FOR Example if booking occured at 1:45 and not 1:00, then then we need to first register 1:00 as not available and that
								  has been done in the in block above. then we need to register :15 ,: 30 as available also so that is what this block is doing. 
								  its runs a while look with step 15 till we reach the min_last_booked (:45)
								*/
								if (check_min_last_booked == 0) {
									var temp_min = 0;
									if (min_last_booked > 15) {
										temp_min = 15;
										while (temp_min < min_last_booked) {
											data = {
												time: this.reformatHour(hour) + ':' + this.reformatMin(temp_min) + ' ' + mer.toUpperCase(),
												service: null,
												data: {
													time: hour + ':' + this.reformatMin(temp_min)
												}
											};
											if (temp.find((d) => d.time == (data.time)) == undefined) {
												temp.push(data);
											}
											temp_min += 15;
										}
									}
								}
								///============-------------------------------============================

								temp.push({
									time: book.time + ' ' + mer.toUpperCase(),
									service: book,
									data: {
										time: 0
									}
								});

								min_last_booked += parseInt(book.time_total);

								if (min_last_booked == 60) {
									this.rem = 0;
								} else if (min_last_booked > 60) {
									this.rem = this.getNextInteval(min_last_booked - 60);
								} else {
									this.rem = 0;
									min_last_booked = this.getNextInteval(min_last_booked);
								}
							}
							if (hour == 18) {
								console.log(books, min_last_booked, this.rem);
							}
						}

					});


					if (!once_inserted && this.rem == 0) {
						//trying to split the min to 15 min interval 
						while (min_last_booked <= 45) {
							data = {
								time: this.reformatHour(hour) + ':' + this.reformatMin(min_last_booked) + ' ' + mer.toUpperCase(),
								service: null,
								data: {
									time: hour + ':' + this.reformatMin(min_last_booked)
								}
							};
							if (temp.find((d) => d.time == (data.time)) == undefined) {
								temp.push(data);
							}

							min_last_booked += 15;
						}
					}
				});
				return temp;
			},
			getNextInteval(minutes) {
				//so that if the minute which the booking is ending doesn't fall into the usual 15 mins interval then this function will correct it by setting the next available booking to next 15 mins interval
				// 0,15,30,45
				var next = 0;
				if (minutes >= 0 && minutes < 16) {
					next = 15;
				} else if (minutes >= 16 && minutes < 31) {
					next = 30;
				} else if (minutes >= 31 && minutes <= 46) {
					next = 45;
				} else {
					next = 50;
				}

				// console.log("next is "+next);
				return next;
			},
			handleEventClick(e) {
				this.getDayEvent(e.event.start);
			},
			sortEvents() {
				var morning = [2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
				var afternoon = [12, 13, 14, 15, 16, 17];
				var evening = [18, 19, 20, 21, 22, 23];

				var hours = [...morning, ...afternoon, ...evening];

				if (this.booking.employee > 0) {
					hours = this.filterEmployeeSchedule(hours);
				}

				morning = morning.filter((m) => hours.find((h) => m == h));
				afternoon = afternoon.filter((m) => hours.find((h) => m == h));
				evening = evening.filter((m) => hours.find((h) => m == h));




				/* 
				   the idea here is this 
				   i picked each interger(hour) and i check if any event on that day (view_events) is booked on/within that hour considering emplpoyees also
				   for example if a booking occured by 9am and the service that was booked has a time of 30 mins then 
				   we will have 9am(booked) and also 9:30am(available) but this must be directed towards a specific employee
				   another example if a booking occure 9am and the service is meant to take 140 mins
				   the  we will have 9am(booked) and also 11:20am(available); the rem variable helps us carry the remainder after substrating 60(1 hour) from the service time, it helps us carry it to the next hour

				*/

				this.morning = this.arrangeTimeWithBookings(morning);
				this.afternoon = this.arrangeTimeWithBookings(afternoon);
				this.evening = this.arrangeTimeWithBookings(evening);
				this.rem = 0;

				// console.log(this.morning);
				// console.log(this.afternoon);
				// console.log(this.evening);
				//let remove the Hours that has pass already
				hours = [];
				var current_time = new Date(new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate());
				if (new Date(this.booking.day).toDateString() == current_time.toDateString()) {
					var hour = new Date().getHours();

					this.morning = this.morning.filter((m) => parseInt(m.time.toString().split(':')[0]) > hour);
					this.afternoon = this.afternoon.filter((m) => parseInt(m.time.toString().split(':')[0]) > hour);
					this.evening = this.evening.filter((m) => parseInt(m.time.toString().split(':')[0]) > hour);
				}


				this.level = 1;
			},
			getDayEvent(dat) {
				var date = new Date(dat);
				var temp_date = date.getFullYear() + '-' + (parseInt(date.getMonth()) + 1);
				var events = this.bookings[temp_date];
				events = events ? events : [];
				temp_date = temp_date + '-' + date.getDate();
				temp_date = this.formatDate(temp_date);
				this.booking.day = temp_date;
				this.view_events = events.filter((d) => d.date == temp_date);
				this.sortEvents();
			},
			formatDate(date) {
				return date.split('-').map((d) => {
					if (d.length < 4) {
						if (d.length < 2) {
							d = '0' + d.toString();
						}
					}
					return d;
				}).join('-');
			},
			toggleEmployee() {
				var date = new Date(this.calendar.state.currentDate);
				this.getBooking(date.getMonth() + 1, date.getFullYear());
				var empl = this.salon.employees.find((d) => d.id == this.booking.employee);
				this.booking.employee_name = empl ? empl.name : 'nije odabrano';

				if (this.booking.employee > 0) {
					//removing services that this employee doesn't offer
					var employee = this.salon.employees.find((empl) => empl.id == this.booking.employee);
					var services = this.salon.services.filter((service) => employee.services.split(",").find((s) => service.name == s));
					this.booking.services = this.booking.services.filter((d) => services.find((f) => f.id == d.id));
				}

				if (this.level > 0) {
					this.getDayEvent(this.booking.day);
				}
			},
			getBooking(month, year) {
				if (this.bookings[year + '-' + month] != undefined) {
					this.events = this.parseEvents(this.bookings[year + '-' + month]);
					return false;
				}

				this.loadingBookings = true;

				this.$store.dispatch('post', {
						endpoint: this.endpoint + 'get-bookings?token=' + this.token,
						details: {
							'salon': this.salon.id,
							month,
							year
						}
					})
					.then((data) => {
						// console.log(data);
						this.bookings = { ...this.bookings,
							...data.data
						};
						this.events = this.parseEvents(this.bookings[year + '-' + month]);

						this.loadingBookings = false;
						// console.log(this.bookings);
					})
					.catch(() => {
						// console.log(error);
						this.loadingBookings = false;
					});
			},
			parseEvents(data) {
				if (this.booking.employee != 0) {
					data = data.filter((d) => d.employee_id == this.booking.employee);
				}

				var temp = [];
				data = data.filter((d) => {
					if (temp.find((n) => n == d.date)) {
						return false;
					} else {
						temp.push(d.date);
						return true;
					}
				});
				data = data.map((d) => {
					return {
						title: 'Booked appointments',
						start: d.date,
						end: d.date,
						classNames: ['event-item']
					};
				});
				// console.log(data);
				return data;
			},
			book() {
				this.bookLoading = true;
				if (this.booking.services.length == 0) {
					this.$store.commit('setNotification', {
						'type': 2,
						msg: 'Molimo Vas odaberite uslugu.'
					});
					return false;
				}
				if (this.booking.day == '') {
					this.$store.commit('setNotification', {
						'type': 2,
						msg: 'Molimo Vas odaberite datum.'
					});
					return false;
				}
				if (this.booking.time == '') {
					this.$store.commit('setNotification', {
						'type': 2,
						msg: 'Molimo Vas odaberite vrijeme.'
					});
					return false;
				}
				// if(this.user.id == this.salon.user_id){
				//     if(this.booking.email.length ==0 ){
				//         this.$store.commit('setNotification',{'type':2,msg:'Please type the customer email in the email textbox'});
				//         return false;
				//     }
				// }

				this.loading = true;
				this.booking.salon = this.salon.id;
				this.$store.dispatch('post', {
						endpoint: this.endpoint + 'book-service?token=' + this.token,
						details: this.booking
					})
					.then((data) => {
						if (data.data.status) {
							this.$store.commit('setNotification', {
								'type': 1,
								msg: 'Zahtjev za rezervaciju je poslan.',
								unset: false
							});
							this.sent = true;
							setTimeout(() => {
								window.location.reload();
							}, 2000);
						} else {
							this.$store.commit('setNotification', {
								'type': 2,
								msg: data.data.message
							});
						}
						this.loading = false;
						this.bookLoading = false;
					})
					.catch(() => {
						// console.log(error.request);
						this.loading = false;
						this.bookLoading = false;
						this.$store.commit('setNotification', {
							'type': 2,
							msg: "Dogodila se neočekivana greška. Molimo Vas provjerite Vašu internet vezu."
						});
					});
			},
			isValid(value) {
				return value != '' && value != null;
			},
			selectService(service) {

				if (this.user == null) {
					window.$("#login-form").modal('show');
					this.$store.state.loader = false;
					return false;
				}

				//				if (!this.isValid(this.user.name) || !this.isValid(this.user.contact) || !this.isValid(this.user.email) || !this.isValid(this.user.receive_notification)) {
				//					window.location.href = "/user#postavke";
				//				return false;
				//				}

				this.employees_services = this.salon.employees.filter((empl) => empl.services.split(',').find((d) => d == service.name));
				if (this.employees_services.length == 0) {
					// alert('We have no employee who currently has the skill to handle this service');
					this.$store.commit('setNotification', {
						'type': 2,
						msg: 'Trenutno nema djelatnika koji pruža ovu uslugu.',
						unset: false
					});
					return false;
				}
				// console.log(this.employees_services,this.salon.upcomingEvents);
				this.booking.employee = this.employees_services[0].id;

				this.booking.services.push(service);
				this.display_book = true;

				setTimeout(() => {
					this.calendar = this.$refs.fullCalendar.getApi();
					var date = new Date(this.calendar.state.currentDate);
					this.getBooking(date.getMonth() + 1, date.getFullYear());
					this.addListener();
				}, 400);
			},
			addListener() {
				var context = this;

				window.$('.fc-next-button').click(function() {
					var date = new Date(context.calendar.state.currentDate);
					context.getBooking(date.getMonth() + 1, date.getFullYear());
					context.addListener();
				});
				window.$('.fc-prev-button').click(() => {
					var date = new Date(context.calendar.state.currentDate);
					context.getBooking(date.getMonth() + 1, date.getFullYear());
					context.addListener();
				});
			},
			verifyOrderDetails() {
				return this.booking.time != '' && this.booking.day != '';
			},
			handleDateClick(arg) {

				// var week=new Date(arg.date).getWeekNumber();
				var year = new Date(arg.date).getFullYear();
				year = year.toString();
				var date = arg.dateStr;
				var selected_day = new Date(arg.date).getTime();
				var current_date = new Date(new Date().toDateString()).getTime();
				if (selected_day < current_date) {
					// alert("you can't select a previous date.");
					this.$store.commit('setNotification', {
						'type': 2,
						msg: "Ne možete odabrati datum koji je prošao."
					});
					return false;
				}
				var check = this.salon.upcomingEvents.find((d) => d.date.toString() == date.toString() && d.year == year && d.shift_id > 0 && this.booking.employee == d.employee_id);

				var check2 = this.salon.upcomingEvents.find((d) => d.date.toString() == date.toString() && d.year == year && d.shift_id > 0);

				//if the current employee doesn't have a shift then we used 'check2' variable to pick any employee that has a shift today but we still need to also check if the employee can offer this service
				if (!check && check2) {
					if (this.employees_services.find((d) => d.id == check2.employee_id)) {
						this.booking.employee = check2.employee_id;
						check = check2;
					}
				}

				if (check) {
					this.booking.day = arg.dateStr;

					//selecting employees who have a schedule for the selected date
					var empls = this.employees_services.filter((e) => {
						return this.salon.upcomingEvents.find((d) => d.employee_id == e.id && d.date == date && d.shift_id > 0);
					});

					//when all employee that offers this service has no shift on this selected date
					if (empls == 0) {
						// alert("All employee that offers this service has no shift at this selected date."+new Date(selected_day).toDateString());
						this.$store.commit('setNotification', {
							'type': 2,
							msg: "Djelatnici koji pružaju ovu uslugu nemaju još određen raspored." + new Date(selected_day).toDateString()
						});
					} else {
						this.employees_services = empls;
						if (this.booking.employee == 0) {
							var randomId = 0;
							this.booking.employee = this.employees_services[randomId].id;
						}
						this.toggleEmployee();
						this.getDayEvent(arg.dateStr);
					}
				} else {
					// alert("The selected employee has no schedule yet for "+new Date(selected_day).toDateString());
					this.$store.commit('setNotification', {
						'type': 2,
						msg: "Salon nema još određen raspored za " + this.custom_date(new Date(selected_day))
					});
				}
			},
			setTime(time) {

				// console.log(time);
				if (time != 0) {

					time = time.toString().search(':') == -1 ? time + ':00' : time;
					var temp = [];
					if (this.booking.employee == 0) {
						temp = this.getAvailableEmpl(time);
					} else {
						temp = this.salon.employees.filter((emp) => emp.id == this.booking.employee);
						// console.log(temp);
					}

					if (temp.length == 0) {
						this.booking.employee = 0;
						this.booking.employee_name = '';
						// alert("All employee's seems busy at this time");
						this.$store.commit('setNotification', {
							'type': 2,
							msg: "Svi djelatnici su zauzeti.",
							unset: false
						});
						return false;
					}

					var selected_service_names = this.booking.services.map((d) => {
						return d.name;
					});
					selected_service_names.sort();

					var empl = temp.find((d) => {
						var d_srvs = d.services.split(',').filter((e) => e != '');
						var result = selected_service_names.filter((serv) => d_srvs.find((es) => es == serv));
						result.sort();
						return result.join(',') == selected_service_names.join(',');
					});
					if (!empl) {
						// alert("Our employees are either busy at time or you might have selected an employee that can't one or some of your selected services. Please pick another employee or you remove some services");
						this.$store.commit('setNotification', {
							'type': 2,
							msg: "Svi djelatnici su zauzeti ili ste odabrali uslugu koju ne mogu pružiti. Molimo vas, izaberite drugog djelatnika ili maknite neke usluge",
							unset: false
						});
						return false;
					}

					if (!this.checkIfTimeIsEnough(time, empl)) {
						return false;
					}

					if (time.toString().split(':')[1].length == 1) {
						time = time.toString() + '0';
					}
					this.booking.time = time;
					this.ready = true;
					// this.booking.employee=empl.id;
					// this.booking.employee_name=empl.name;
					return true;
				}
			},
			getAvailableEmpl(time) {
				var temp = [];
				var year = new Date(this.booking.day).getFullYear();
				var date = new Date(this.booking.day).getFullYear() + '-' + this.reformatMonth((new Date(this.booking.day).getMonth() + 1)) + '-' + this.reformatMonth(new Date(this.booking.day).getDate());
				var schedules = this.salon.upcomingEvents.filter((d) => d.date.toString() == date.trim().toString() && d.year == year && d.shift_id > 0);
				// console.log(schedules);
				var employees = schedules.map((d) => {
					var start = parseFloat(d.shift.start.replace(':', '.'));
					var end = parseFloat(d.shift.end.replace(':', '.'));
					var hours = [];
					while (start <= end) {
						hours.push(start);
						start += 1;
					}
					d.hours = hours;
					return d;
				});
				// console.log(employees);
				employees = this.salon.employees.filter((ew) => {
					return employees.find((d) => {
						return d.employee_id == ew.id && d.hours.find((we) => we == time.split(':')[0])
					}) != undefined
				});
				// console.log(time);
				temp = this.view_events.filter((d) => this.getPrecision(d.time) == this.getPrecision(time));
				temp = employees.filter((d) => !temp.find((r) => r.employee_id == d.id));

				return temp;
			},
			toMinutes(v) {
				var hour = 60;
				var spltd = v.toString().split('.');
				v = 0;
				v += parseInt(spltd[0]) * hour;
				if (spltd[1]) {
					v += parseInt(spltd[1]);
				}
				return v;
			},
			checkIfTimeIsEnough(time, empl) {
				//I AM CHECKING IF THE INTERVAL BETWEEN THE SELECTED TIME AND THE NEXT BOOKED TIME WILL BE ENOUGH FOR THE SELECTED SERVICES
				var bookings_at_this_hour = this.view_events.filter((d) => d.employee_id == empl.id);
				// console.log(bookings_at_this_hour,empl.id);

				//Getting employee's schedule for this day so we can even know the last hour of his work
				var schedules = this.salon.upcomingEvents.find((d) => d.employee_id == this.booking.employee && d.date.toString() == this.booking.day && d.year == new Date().getFullYear().toString() && d.shift_id > 0);
				var schd_end = schedules.shift.end;
				var schd_end_minutes = this.toMinutes(schd_end.split(':')[0]) + parseInt(schd_end.split(':')[1]);
				// console.log(schedules,schd_end);
				//-----------------------------//

				var booked_times = JSON.parse(JSON.stringify(bookings_at_this_hour)); //to avoid passing value by reference
				booked_times = booked_times.map((bk) => {
					bk.time = parseFloat(bk.time.replace(':', '.')).toFixed(2);
					return bk.time;
				});
				booked_times.push(time.replace(':', '.'));
				// booked_times.push((schedules.hours[schedules.hours.length-1]+1));
				// console.log(booked_times);
				booked_times = booked_times.map((hrs) => {
					return parseInt(this.toMinutes(hrs));
				});
				booked_times.push(schd_end_minutes);
				// console.log(booked_times);
				booked_times.sort((a, b) => a - b);
				// console.log(booked_times); 

				var index_of_selected_time = booked_times.indexOf(this.toMinutes(time.replace(':', '.')));
				// console.log('index = '+index_of_selected_time,'=='+booked_times[index_of_selected_time]); 
				if (index_of_selected_time >= 0 && index_of_selected_time <= (booked_times.length - 2)) {
					// console.log(parseFloat(booked_times[index_of_selected_time+1]).toFixed(2),parseFloat(booked_times[index_of_selected_time]));
					var mins_rem = parseFloat(parseFloat(booked_times[index_of_selected_time + 1]).toFixed(2) - parseFloat(booked_times[index_of_selected_time]).toFixed(2)).toFixed(2);
					var time_total = 0;
					this.booking.services.forEach((e) => {
						time_total += parseInt(e.time);
					});
					if (time_total > mins_rem) {
						// alert('You can selected this time because The total time required for your selected services is '+time_total+'mins');
						this.$store.commit('setNotification', {
							'type': 2,
							msg: 'Potrebno vrijeme je najmanje ' + time_total + ' minuta.',
							unset: false
						});
						return false;
					}
				}
				return true;
			},
			getPrecision(value) {
				return parseFloat(value.replace(':', '.')).toFixed(2).replace('.', ':');
			},
			checkFavorite() {
				this.$store.dispatch('get', this.endpoint + "check-salon-favorites/" + this.user.id + '/' + this.salon.id + "?token=" + this.token)
					.then((data) => {
						// console.log(data);
						if (data.data == 1) {
							this.favoriteAlready = true;
						} else {
							this.favoriteAlready = false;
						}
					});
				// .catch((error)=>{
				//     console.log(error.request);
				// })
			},
			loadComment(page) {
				this.loadingComment = true;
				// this.$store.state.loader = true;
				this.$store.dispatch('get', this.endpoint + 'get-salon-comments/' + this.salon.id + '?page=' + page)
					.then((data) => {
						// console.log(data.data);
						this.comments = data.data.data;
						this.comment_current_page = data.data.current_page;
						this.last_page = data.data.last_page;
						this.pagination = [];
						for (var c = 1; c <= data.data.last_page; c++) {
							this.pagination.push(c);
						}
						this.loadingComment = false;
					})
					.catch(() => {
						// console.log(error.request);
						this.loadingComment = false
					});

			},
			removeToFavorite() {
				this.favoriteAlready = false;
				this.$store.dispatch('get', this.endpoint + "remove-favorite-salon/" + this.user.id + '/' + this.salon.id + "?token=" + this.token);
				// .then((data)=>{
				//     console.log(data);

				// })
				// .catch((error)=>{
				//     console.log(error.request);
				// })
			},
			addToFavorite() {
				this.favoriteAlready = true;
				this.$store.dispatch('get', this.endpoint + "add-favorite-salon/" + this.user.id + '/' + this.salon.id + "?token=" + this.token);
				// .then((data)=>{
				//     console.log(data);
				// })
				// .catch((error)=>{
				//     console.log(error.request);
				// })
			},
			fetch() {
				this.fetching = true;
				this.$store.state.loader = true;
				this.$store.dispatch('post', {
						endpoint: this.endpoint + 'get-salon/' + this.$route.params.name,
						details: {
							salon_name: this.$route.params.name
						}
					})
					.then((data) => {
						console.log(data);
						this.$store.state.loader = false;
						data.data.related = data.data.related.map((d) => {
							var pimage = d.images.find((d) => d.type == 2);
							d.profile_image = pimage ? pimage.filename : '';
							return d;
						});
						this.$store.state.salon = data.data;
						this.fetching = false;

						// console.log(this.salon);
						if (this.user != null) {
							this.checkFavorite();
						}
						this.loadComment(1);
						this.checkIfUserHasComment();

						this.featuredSalon();

						this.sortWorkingHours();

						if (this.$route.hash != '') {
							var id = this.$route.hash.replace('#book', '');
							var service = this.salon.services.find((d) => d.id == id);
							if (service != null) {
								window.$("#display_book").modal('show');
								this.selectService(service);
							}
						}
					})
					.catch((error) => {
						// console.log(error.request);
						if (error.request.status == 404) {
							this.$router.push('/salon-list');
						}
						this.$store.dispatch("handleError", error);
						this.fetching = false;
						this.$store.state.loader = false;
					});
			},
			setImage(id) {

				var index = 0;
				var counter = 0;
				this.$store.state.salon.images.forEach((img) => {
					if (img.id == id) {
						// console.log('found', index);
						// counter+=1;
						index = counter;
					} else {
						counter += 1;
					}
				});
				// console.log(index);
				this.$store.state.photos = this.$store.state.salon.images;
				this.$store.state.image_viewer = true;
				this.$store.state.active_image = index;
				window.scrollTo(0, 0);
			},
			sortImages(photos) {
				var data = {
					home_picture: '',
					profile_picture: '',
					featured_picture: []
				};
				data.home_picture = photos.find((d) => d.type == 1);
				data.profile_picture = photos.find((d) => d.type == 2);
				data.featured_picture = photos.filter((d) => d.type == 3);

				data.home_picture = data.home_picture != undefined ? data.home_picture.filename : ''
				data.profile_picture = data.profile_picture != undefined ? data.profile_picture.filename : ''

				return data;
			},
			checkIfUserHasComment() {
				this.$store.dispatch('get', this.endpoint + 'check-user-has-comment/' + this.salon.id + '?token=' + this.token)
					.then((data) => {
						// console.log(data);
						if (data.data.status) {
							this.canComment = true;
							this.comment.user = this.user;
							this.comment.salon = this.salon.id;
						}
					});
			},
			sortWorkingHours() {
				var working_hours = this.salon.working_hours;
				this.days = this.days.map((d) => {
					var current = working_hours.find((t) => t.day == d.value);
					if (current) {
						d.data.start = current.start;
						d.data.ps = current.ps;
						d.data.pk = current.pk;
						d.data.end = current.end;
					}
					return d;
				});
			},
			sortServices() {
				var services = [];
				if (this.booking.employee == 0) {
					services = this.salon.services;
				} else {
					var employee = this.salon.employees.find((empl) => empl.id == this.booking.employee);
					services = this.salon.services.filter((service) => employee.services.split(",").find((s) => service.name == s));
				}
				this.available_services = services;
				this.showServices = true;
			},
			featuredSalon() {
				this.loading = true;
				this.$store.dispatch('get', this.$store.state.endpoint + "get-featured-salon")
					.then((data) => {
						// console.log(data);
						data.data = data.data.map((d) => {
							var pimage = d.images.find((d) => d.type == 2);
							d.profile_image = pimage ? pimage.filename : '';
							return d;
						});
						data.data = data.data.filter((d) => d.id != this.salon.id);
						this.$store.state.featured_salons = data.data;

						this.loading = false;
						setTimeout(() => {
							window.$('.active-recent-blog-carusel').owlCarousel({
								nav: false,
								navContainer: '.custom-nav',
								items: 4,
								loop: true,
								margin: 0,
								dots: true,
								autoplayHoverPause: true,
								smartSpeed: 300,
								autoplay: true,
								responsive: {
									0: {
										items: 2,
									},
									576: {
										items: 2,
									},
									768: {
										items: 3,
									},
									992: {
										items: 4,
									},
									1200: {
										items: 5
									},

								}
							});
							// setTimeout(()=>{
							// document.getElementById('salonCarol').style.opacity='1';
							// },500);
						}, 100);
					});
				// .catch((error)=>{
				//     console.log(error);
				//     // this.loading=false;
				// })
			},
			changeBotunText() {
				if (this.botunText === "Prikaži više") {
					this.botunText = "Prikaži manje";
				} else {
					this.botunText = "Prikaži više"
				}
			},
			custom_date(date) {
				var custom_months = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
				var custom_days = ["nedjelju", "ponedjeljak", "utorak", "srijedu", "četvrtak", "petak", "subotu"];
				var customDate = custom_days[date.getDay()] + ", " + this.reformatHour(date.getDate()) + "." + custom_months[date.getMonth()] + "." + date.getFullYear() + ".";
				// var time = unixDate.getHours() + ":" + unixDate.getMinutes();
				return customDate;
			}
		},
		created() {
			this.fetch();
			Date.prototype.getWeekNumber = function() {
				var d = new Date(Date.UTC(this.getFullYear(), this.getMonth(), this.getDate()));
				var dayNum = d.getUTCDay() || 7;
				d.setUTCDate(d.getUTCDate() + 4 - dayNum);
				var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
				return Math.ceil((((d - yearStart) / 86400000) + 1) / 7)
			};
		},
		updated() {
			setTimeout(() => {
				if (this.$route.hash) {
					var el = document.querySelector(this.$route.hash);
					el.scrollIntoView({
						behavior: 'smooth',
						block: 'start'
					});
				}
			})
		}
	}

</script>

<style scoped>
	.booked {
		font-size: 10px;
		font-weight: 400;
		color: red !important;
	}

	.available {
		font-size: 10px;
		font-weight: 400;
		color: green !important;
	}

	.open {
		position: absolute;
		left: 0;
		right: 0;
		margin: auto;
		background: white;
	}

	.closed {
		display: none !important;
	}

	.add-book {
		color: grey;
		width: 100%;
		text-align: center;
		display: block;
	}

	.add-book a i.fas {
		color: #80808094;
	}

	.add-book a span {
		color: #80808094;
		padding: 0px 0px 4px 0px;
	}

	.mer {
		border: none;
		padding: 12px 0px;
		margin: 0px;
	}

	.apmt {
		margin-top: 20px;
	}

	.time-box {
		width: 100%;
		text-align: center;
	}

	.time-box-time {
		display: inline-block;
		width: 50px;
		font-size: 0.8em;
	}

	.time-apmt-box {
		border: 1px solid #ed406d;
		border-radius: 5px;
		margin-bottom: 5px;
		margin-right: 5px;
		transition: all .2s linear;
	}

	.time-apmt-box .inner {
		padding: 0px 10px;
	}

	.time-apmt-box:hover {
		cursor: pointer;
		background: #ed406d;
	}

	.time-apmt-box:hover .booked {
		color: white !important;
	}

	.time-apmt-box:hover .available {
		color: white !important;
	}

	.time-apmt-box:hover .add-book i {
		color: white;
	}

	.time-apmt-box:hover .add-book span {
		color: white;
	}

	.time-apmt-box:hover .time-box {
		color: white;
	}

	.time-apmt-box:hover .inner {
		color: white;
	}

	.time-apmt-box b {
		overflow: hidden;
	}

	.time-apmt-box span {
		overflow: hidden;
		overflow: hidden;
		display: flex;
		justify-content: space-between;
	}

	.selectedTime {
		cursor: pointer;
		background: #ed406d;
	}

	.selectedTime .booked {
		color: white !important;
	}

	.selectedTime .available {
		color: white !important;
	}

	.selectedTime .add-book i {
		color: white !important;
	}

	.selectedTime .add-book span {
		color: white;
	}

	.selectedTime .time-box {
		color: white;
	}

	.selectedTime .inner {
		color: white;
	}

	.tool {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	@media (max-width: 600px) {
		.tool .btn {
			margin-right: 10px;
		}

		.tool h4 {
			text-align: right;
		}
	}

</style>
<style>
	.event-item {
		color: white !important;
		padding: 5px !important;
		border-radius: 2px !important;
	}

</style>
<style lang='scss'>
	@import '~@fullcalendar/core/main.css';
	@import '~@fullcalendar/daygrid/main.css';

</style>
<style scoped>
	.bk-subt {
		font-weight: bold;
	}

	.aptc {
		display: inline-block;
	}

	td {
		border: none;
	}

	.loading {
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background: #0000008c;
		z-index: 9;
	}

	.loading .loader {
		position: absolute;
		margin: auto;
		height: 100px;
		top: 0;
		bottom: 0;
		width: 300px;
		text-align: center;
		left: 0;
		right: 0;
	}

	.nd_part {}

	.raise {}

	.prop b {
		text-align: left;
	}

	.prop span {
		text-align: right;
		width: 50%;
	}

	.prop {
		display: flex;
		justify-content: space-between;
		padding: 5px 0px;
	}

	#content {
		position: relative;
	}

	.sent {
		background: white;
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		width: fit-content;
		height: fit-content;
		margin: auto !important;
		padding: 20px 20px !important;
		border-radius: 5px;
		overflow: auto !important;
	}

	.rowcontent {
		background: #f7f7f7;
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		margin: auto !important;
		height: 95%;
		width: 95%;
		max-width: 1200px;
		max-height: 950px;
		padding: 10px 10px 20px 10px !important;
		overflow: auto !important;
	}

	.rowcontent.ready {
		background: transparent;
	}

	#bookMod {
		position: fixed;
		z-index: 9999;
		top: 0;
		bottom: 0;
		width: 100%;
		background: #00000069;

	}

	.pagination {
		margin-top: 40px;
		justify-content: center;
	}

	.response {
		background: #d3d3d330;
		width: 80%;
		margin-left: auto;
		margin-top: 20px;
	}

	@media (max-width: 576px) {
		.nd_part {
			padding-top: 20px !important;
		}

		.rowcontent {
			height: 100%;
			width: 100%;
			padding: 0px 0px 5px 0px !important;
		}

		.rowcontent.ready {
			background: transparent;
		}

		.open {
			padding-top: 15px !important;
		}

		#bookMod {
			background: #f7f7f7;
		}
	}

	.btn-group-book {
		display: flex;
	}

	.btn-group-book button {
		flex: 1;
	}

</style>
